<template>
  <div class="pay-page" v-loading="pageLoading">
    <!-- header 头部 -->
    <div class="header-content">
      <header class="header-con">
        <img class="logo" src="./images/logo.png" alt="logo" />
        <div class="user-info">
          <span>{{ userLogin.nick || '' }}</span>
          <span
            ><img
              style="width: 40px; height: 40px; margin-left: 5px;border-radius: 50%;"
              :src="userLogin.header || ''"
              alt="头像"
          /></span>
        </div>
      </header>
    </div>

    <div class="center-con">
      <div class="main-con">
        <div class="wihte-con">
          <div class="back_btn" @click="backFn()">
            <i class="el-icon-arrow-left"></i>
            <span class="back_text">返回</span>
          </div>
          <!-- 支付页面 -->
          <header class="pay_title">确认订单信息</header>
          <div class="course_con">
            <!-- 课程详情 -->
            <div class="img-con">
              <img :src="coverImg" alt="直播封面" />
            </div>
            <div class="course_info">
              <div class="course_title">{{ cursonTitle }}</div>
              <!-- <span class="course_stock">库存:{{ 50 }}</span> -->
              <span class="course_price">¥{{ price }}</span>
            </div>
          </div>
           <!-- *课程提醒发送至 -->
           <div class="remind_text" v-if="extData.length">
            <i class="red-icon">*</i>课程提醒发送至
          </div>
          <el-form class="remind_con" label-position="left" label-width="auto">
            <el-form-item style="margin-right: 20px;" :label="item.name" :title="item.name" v-for="(item, index) in extData" :key="index">
              <el-input v-model="item.value" :placeholder="`请输入${item.name}`"></el-input>
            </el-form-item>
          </el-form>
          <!-- 支付方式 -->
          <div class="pay_way">选择支付方式</div>
          <div class="pay_way_con">
            <div
              class="pay_way_item"
              :class="{ active: payType === index }"
              v-for="(item, index) in payItems"
              :key="index"
              @click="payFn(item, index)"
            >
              <img :src="item.logo" :alt="item.name + 'logo'" />
              <span class="pay_name">{{ item.name }}</span>
            </div>
          </div>
        </div>

      <!-- 支付 -->
      <div class="pay_btn_con">
        <span class="pay_value">
          <span class="pay_name">实付金额：</span>
          <span class="pay_num">¥{{ price }}</span>
        </span>
        <!-- 立即支付按钮 -->
        <div class="pay_btn" @click="buyNowFn()">立即支付</div>
      </div>
    </div>
    </div>

    <!-- 底部 -->
    <div class="footer">
      <div class="xinxiyang">
        <p style="font-size: 18px;color: #fff;">公司信息</p>
      </div>
      <p style="color: rgb(238, 240, 241);margin-top: 5px; font-size: 16px;">
        珊瑚云直播提供技术支持
      </p>
      <p style="margin: 10px 0 15px 0;">
        <a
          style="color: rgb(238, 240, 241);font-size: 16px;"
          href="https://www.shanhuketang.com/index.html"
          >www.shanhuketang.com</a
        >
      </p>
    </div>

    <!-- 二维码弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="604px"
      >
      <div style="text-align: center;"><span class="ershifu">实付金额:</span><span class="erjine">¥{{ price }}</span></div>
      <canvas
          id="qrccode-canvas"
          class="xiaotan"
      ></canvas>
      <div class="weixinsaoma">{{zhifuwz}}</div>
  </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcode'
import tool, { payOpenClassHost } from '@/kits/Tools.js'
import qs from 'qs'

export default {
  name: 'Pay',
  data () {
    return {
      pageLoading: false,
      dialogVisible: false,
      payType: 0, // 0: 微信支付 1: 支付宝支付
      showExtMsg: false,
      zhifuwz: '请打开微信扫码支付',
      payItems: [
        { name: '微信支付', logo: require('./images/wechat.png') },
        { name: '支付宝支付', logo: require('./images/zhifubao.png') }
      ],
      price: '',
      coverImg: '',
      title: '',
      cursonTitle: '',
      telVal: '',
      nameVal: '',
      telShow: false,
      nameShow: false,
      extData: [],
      params: {},
      flag: '',
      order_no: '',
      uid: '',
      opid: '',
      channel_id: '',
      setTime: null,
      userLogin: {},
      setCheckPay: null
    }
  },
  computed: {
  },
  methods: {
    checkOrderPayStatus () {
      const data = {
        orderno: this.order_no
      }
      this.axios
        .post(
          'https://school.shkt.online/payapi/checkOrderPayStatus',
          qs.stringify(data)
        )
        .then(res => {
          if (res.data.code === 200) {
            if (res.data.data === 'yes') {
              clearTimeout(this.setCheckPay)
              this.$router.push({ name: 'index' })
            } else {
              this.setCheckPay = setTimeout(() => {
                this.checkOrderPayStatus()
              }, 4000)
            }
          }
        })
    },
    payFn (item, index) {
      this.payType = index
    },
    backFn () {
      clearTimeout(this.setCheckPay)
      this.$router.push({
        name: 'DetailPage'
      })
    },
    createQrc (item, canvas) {
      QRCode.toCanvas(canvas, item, error => {})
      // 查询是否支付成功
      this.checkOrderPayStatus()
    },
    buyNowFn () {
      // 立即购买
      if (this.setTime) {
        clearTimeout(this.setTime)
      }
      this.setTime = setTimeout(() => {
        this.zhifutank()
      }, 500)
    },
    zhifutank () {
      if (this.extData && this.extData.length) {
        const extObj = {}
        const noValueArr = []
        Object.values(this.extData).forEach(ele => {
          if (ele.required === '1') {
            extObj[ele.id] = ele.value
            if (!ele.value) {
              noValueArr.push(ele.name)
            }
          }
        })
        console.log(extObj)
        if (noValueArr.length) {
          this.$message({
            message: `请填写${noValueArr[0]}`,
            type: 'error'
          })
          return
        }
        let data = {
          ds_id: this.ds_id,
          fans_id: this.fans_id
        }
        if (this.channel_id) {
          data.channel_id = this.channel_id
        }

        data = { ...data, ...extObj }
        console.log(data, '参数啊')
        this.axios
          .post(
            `${payOpenClassHost()}/liveapi/api/ds/submitOrder`,
            qs.stringify(data)
          )
          .then(res => {
            if (res.data.code === 200) {
              this.order_no = res.data.data.order_no
              this.dialogVisible = true
              this.zhifuwz = '请打开微信扫码支付'
              this.flag = 1
              if (this.payType) {
                this.zhifuwz = '请打开支付宝扫码支付'
                this.flag = 3
              }
              this.handlePayRequest(
                res.data.data.money,
                res.data.data.order_no,
                this.flag
              )
            } else {
              this.$message({
                message: `${res.data.message}`,
                type: 'error'
              })
            }
          })
      } else {
        let data = {
          ds_id: this.ds_id,
          fans_id: this.fans_id
        }
        if (this.channel_id) {
          data.channel_id = this.channel_id
        }
        data = { ...data }
        this.axios
          .post(
            `${payOpenClassHost()}/liveapi/api/ds/submitOrder`,
            qs.stringify(data)
          )
          .then(res => {
            if (res.data.code === 200) {
              console.log(res.data.data)
              this.order_no = res.data.data.order_no
              this.dialogVisible = true
              this.zhifuwz = '请打开微信扫码支付'
              this.flag = 1
              if (this.payType) {
                this.zhifuwz = '请打开支付宝扫码支付'
                this.flag = 3
              }
              this.handlePayRequest(
                res.data.data.money,
                res.data.data.order_no,
                this.flag
              )
            }
          })
      }
    },
    handlePayRequest (money, orderNo, flag) {
      let data = {
        money: money,
        orderno: orderNo,
        opid: this.opid,
        uid: this.uid,
        flag
      }
      if (this.fans_id) {
        data.fansid = this.fans_id
      }
      this.axios
        .post('https://school.shkt.online/payapi/pcCartPay', qs.stringify(data))
        .then(res => {
          if (res.data.code === 200) {
            this.zhifuerweima = res.data.data
            this.$nextTick(function () {
              // DOM操作
              const canvas = document.getElementById('qrccode-canvas')
              this.createQrc(this.zhifuerweima, canvas)
            })
          }
        })
    },
    getDetailPageFn () {
      this.pageLoading = true
      const url = `${payOpenClassHost()}/liveapi/api/ds/payOpenInfo`
      this.axios.post(url, qs.stringify({ ds_id: this.ds_id, fans_id: this.fans_id })).then(res => {
        if (res.data.code === 200) {
          // 封面
          this.coverImg = res.data.data.cover || ''
          // 价格
          const params = JSON.parse(res.data.data.params)
          this.price = params.price
          if (params.price && params.discount_price) {
            this.price = params.discount_price
          }
          const extData = JSON.parse(params.ext)
          extData.forEach(element => {
            const obj = {
              id: element.id,
              name: element.name,
              value: '',
              required: element.required
            }
            this.extData.push(obj)
          })
          this.cursonTitle = res.data.data.name
          // 传给支付的opid
          this.opid = params.opid
          this.pageLoading = false
          if (res.data.data && res.data.data.is_pay) {
            // 如果已经支付完跳转首页
            this.$router.push({name: 'index'})
          }
        } else {
          this.pageLoading = false
          this.$router.push({name: 'index'})
        }
      }).catch(err => {
        this.pageLoading = false
        this.$router.push({name: 'index'})
        console.log(err)
      })
    },
    async getDsIdFn () {
      this.pageLoading = true
      const data = await this.axios.post(
        tool.baseUrl2() + '/customer/channel/getDsIdByChannelId',
        'channel_code=' + this.channel_id, { timeout: 6000 }
      )
      if (data.data.code === 200) {
        this.ds_id = data.data.data.ds_id
        this.getDetailPageFn()
      } else {
        this.$alert(data.data.message, '', {
          showConfirmButton: false,
          showClose: false,
          type: 'warning',
          center: true
        })
        return false
      }
    }
  },
  watch: {

  },
  created () {
    this.ds_id = tool.getQueryString('ds_id') || localStorage.getItem('ds_id')
    this.channel_id = tool.getQueryString('channel_id') || localStorage.getItem('channel_id')
    // 机构id
    this.uid = localStorage.getItem('uid')
    this.fans_id = localStorage.getItem('fans_id')
    var userInfo = tool.getCookie('userInfo')
    if (userInfo) {
      this.userLogin = JSON.parse(userInfo)
    }
    if (!this.ds_id && this.channel_id) {
      this.getDsIdFn()
    } else {
      this.getDetailPageFn()
    }
  },
  mounted () {},
  beforeDestroy () {
    clearTimeout(this.setCheckPay)
  },
  destroyed () {
    clearTimeout(this.setCheckPay)
  }
}
</script>

<style scoped>
.pay-page {
  width: 100%;
  height: 100%;
  background: #f5f6f7;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header-content {
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  justify-content: center;
}
.header-con {
  width: 1260px;
  height: 68px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}
.header-con .logo {
  width: 178px;
  height: 44px;
  object-fit: cover;
}
.user-info {
  display: flex;
  align-items: center;
}
.center-con {
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.main-con {
  width: 1260px;
  border-radius: 1px;
  /* box-sizing: border-box; */
}
.wihte-con {
  padding: 20px 40px 30px 40px;
  background: #ffffff;
}
.back_btn {
  display: flex;
  cursor: pointer;
  width: 62px;
}
.el-icon-arrow-left {
  color: #4d4d4d;
}
.back_text {
  color: #4d4d4d;
  font-size: 16px;
  margin-left: 8px;
}
.pay_title {
  color: #202020;
  font-size: 20px;
  font-weight: 600;
  margin: 30px 0 15px 0;
}
.course_con {
  /* 封面 */
  width: 100%;
  height: 210px;
  padding: 30px 20px;
  box-sizing: border-box;
  display: flex;
  border: 1px solid #e8eaec;
}

.course_con .img-con {
  width: 258px;
  height: 150px;
}
.img-con img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.course_info {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.course_title {
  height: 33px;
  line-height: 33px;
  color: #4d4d4d;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
}
.course_stock {
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #999999;
  margin-top: 40px;
}
.course_price {
  height: 37px;
  line-height: 37px;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #ff3700;
}
/* 支付 */
.pay_way {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #202020;
  margin: 30px 0;
}
.remind_text {
  color: #4d4d4d;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  margin: 30px 0 20px 0;
}
.red-icon {
  color: #ff5227;
  font-style: normal;
}
.remind_con {
  min-width: 76%;
  max-width: 82%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.item-con {
  padding: 10px 15px 10px 0;
}
.item-con .name-title {
  margin-right: 20px;
  color: #202020;
  font-size: 14px;
  font-family: PingFangSC-Regular;
}
.name-con,
.phone-con {
  display: flex;
  align-items: center;
  width: 380px;
  height: 36px;
  margin-right: 10px;
}

.name-con .name-title,
.iphone {
  margin-right: 20px;
}
>>> .el-input {
  width: 280px;
  height: 36px;
  margin-right: 10px;
}

>>> .el-input__inner {
  width: 280px;
  height: 36px;
}
.pay_way_con {
  display: flex;
}
.pay_way_item {
  width: 310px;
  height: 80px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #dee2e9;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  cursor: pointer;
}
.active {
  border: 2px solid #42b034;
}
.pay_way_item .pay_name {
  font-size: 26px;
  margin-left: 20px;
  color: #202020;
  font-family: PingFang SC, PingFang SC-Medium;
}
.pay_btn_con {
  margin-top: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 158px;
  background: #ffffff;
  border: 1px solid #e8eaec;
  border-radius: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  margin-bottom: 15px;
}
.pay_value .pay_name {
  color: #202020;
  font-size: 26px;
  font-family: PingFang SC, PingFang SC-Medium;
}
.pay_value .pay_num {
  color: #ff3700;
  margin-left: 9px;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
}
.pay_btn {
  width: 232px;
  height: 62px;
  background: #ff571f;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

/* 底部样式 */
.footer {
  width: 100%;
  height: 130px;
  background: rgb(21, 21, 21);
  text-align: center;
  margin-top: 184px;
}

.xinxiyang {
  width: 100%;
  padding: 15px 0;
  text-align: center;
  display: flex;
  justify-content: center;
}

</style>

<style scoped>

.xiaotano >>> .el-dialog {
  border-radius: 16px;
}
.weixinsaoma {
  font-size: 16px;
  font-family: PingFangSC-Regular;
  text-align: center;
  color: #20242f;
}
.xiaotan {
  width: 280px !important;
  height: 280px !important;
  margin-left: 140px;
  margin-top: 9px;
}
.erjine {
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #ff3700;
  margin-left: 10px;
}
.ershifu {
  font-size: 22px;
  font-family: PingFangSC-Regular;
  color: #20242f;
}
.lihifu {
  width: 232px;
  height: 62px;
  background: #ff571f;
  border-radius: 4px;
  border: none;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #ffffff;
  margin-left: 677px;
  margin-top: 48px;
}
.zhifje {
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #ff3700;
  line-height: 158px;
  margin-left: 9px;
}
.shishizf {
  font-size: 26px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #202020;
  line-height: 158px;
  margin-left: 40px;
}
.zhifuwzs {
  font-size: 26px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #202020;
}
.zg {
  border: 2px solid #42b034 !important;
}
.wxzhifu {
  width: 308px;
  height: 78px;
  background: #ffffff;
  border: 1px solid #dee2e9;
  /* margin-left: 40px;
    margin-top: 30px;
    margin-bottom: 40px; */
}
.zhifufs {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #202020;
  margin-left: 40px;
  margin-top: 20px;
}
.forxunhuan >>> .el-form-item__label {
  color: #202020;
}
.wentishuru {
  width: 260px;
  height: 36px;
  background: #ffffff;
  /* border: 1px solid #eaebec; */
  border-radius: 2px;
}
.tixing span {
  color: #ff5227;
}
.tixing {
  margin-left: 40px;
  margin-top: 20px;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #202020;
}
.qianshu {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #ff3700;
  margin-left: 22px;
  margin-top: 80px;
}
.ershicp {
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #4d4d4d;
  margin-left: 20px;
  margin-top: 30px;
}
.zhifuxinxi {
  width: 1180px;
  height: 210px;
  background: #ffffff;
  border: 1px solid #e8eaec;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
}
.querandindan {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #202020;
  margin-top: 33px;
  margin-left: 40px;
}
.fanhuilist {
  font-size: 16px;
  font-family: PingFangSC-Regular;
  color: #4d4d4d;
  margin-top: 20px;
  margin-left: 35px;
  cursor: pointer;
}
.zhifuding {
  width: 1260px;
  height: 100%;
  background: #ffffff;
  border-radius: 1px;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 20px;
  overflow: hidden;
}
.lijizhifu {
  width: 1260px;
  height: 158px;
  background: #ffffff;
  border: 1px solid #e8eaec;
  border-radius: 1px;
  margin: 0 auto;
  margin-bottom: 20px;
  overflow: hidden;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/paidPublicClass/pay.vue